import React, { useState, useEffect, useMemo } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import { connect } from 'react-redux';
import { getSocietes } from '../../flux/actions/societeActions';
import { ICommissionPaymentComponentReduxProps, ICommissionPaymentComponent, ITarget } from '../../types/interfaces';

import Select from 'react-select';
import { PRIVILEGE } from '../../types/privileges';

const CommissionPaymentComponent = ({
    user,
    getSocietes,
    societe,
    selectedUser,
    setSelectedUser,
    societeValue,
    setSocieteValue,
    commentValue,
    setCommentValue,
    auth
  }: ICommissionPaymentComponent) => {
  const { users, loading: loadingU } = user;
  const { societes, loading: loadingS } = societe;
  const societeOptions = [{value: {id: "ALL", LIBELE: "Tous les projets"}, label: "Tous les projets"}, ...societes.map(e => ({value: e, label: e.LIBELE}))];
  const userOptions = (auth?.user?.privileges?.includes(PRIVILEGE.OTHERS_COMMISSIONS) ? [{id: "ALL", LOGIN: "Tous les commerciaux"}, ...users.map(e => ({id: e.id, LOGIN: e.username}))] : [{id: auth?.user?.id, LOGIN: auth?.user?.username}]).map(e => ({value: e.id, label: e["LOGIN"] || e["username"], user: e}));

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []);
  }, [getSocietes, auth]);

  // useEffect(() => {
  //   auth && auth.user && getChantiers(auth?.user.chantiers?.map(e => e.id) || [], auth.user.role || 0);
  // }, [getChantiers, auth]);

  const handleUserChange = data => {
    setSelectedUser(data ? data.user : '');
  }
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
  }
  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);

  return (
    <div>
      <Container className="addPaymentDiv">
        <Row className="justify-content-center">
          <Col xs="12" sm="6">
            <FormGroup>
              <Label for="user">Commercial</Label>
              <Select
                name="user"
                className="reactselect"
                classNamePrefix="react-select"
                value={selectedUser ? {label: selectedUser["LOGIN"] || selectedUser["username"], value: selectedUser.id, user: selectedUser} : null}
                onChange={handleUserChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                isLoading={loadingU}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                // labelKey='LOGIN'
                // valueKey='countryCode'
                options={userOptions}
              />
            </FormGroup>
          </Col>
          {/* <Col xs="12" sm="6">
            <FormGroup>
              <Label for="societe">Société</Label>
              <Select
                name="reactselect"
                className="reactselect"
                classNamePrefix="react-select"
                id="societe"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par projet...'}
                isClearable={true}
                isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                // valueKey='code'
                options={societeOptions}
              />
            </FormGroup>
          </Col> */}
          <Col xs="12" sm="6">
            <FormGroup>
              <Label>Observation</Label>
              <Input type="text" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} className="form-control" />
            </FormGroup>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

// const mapStateToProps = (state: IPaymentComponentReduxProps) => ({
//   fournisseur: state.fournisseur,
//   isAuthenticated: state.auth.isAuthenticated
// });

const mapStateToProps = (state: ICommissionPaymentComponentReduxProps) => ({
  user: state.user,
  societe: state.societe,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getSocietes })(CommissionPaymentComponent);
